import React from 'react';


const IklanContext = React.createContext();

const useIklan = () => {
  return React.useContext(IklanContext);
};

//Optional HOC
const withIklan = (Component) => (props) => {
  const iklan = useIklan();

  return <Component {...props} iklan={iklan} />;
};

// if ref is used
/* const withLanguage = (Component) =>
  React.forwardRef((props, ref) => {
    const language = useLanguage();

    return <Component {...props} ref={ref} language={language} />;
  }
); */

const IklanProvider = ({ children }) => {

  const [adsMode, setAdsMode] = React.useState("banner-bottom");

  return (
    <IklanContext.Provider value={{
      adsMode, 
      setAdsMode,
    }}>
      {children}
    </IklanContext.Provider>
  );
};


export { IklanProvider, useIklan ,withIklan };